import { TertiaryButton, Typography, WebsitePrimaryButton } from "@dev/ee-components";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux";
import { useTablet } from "@/services/hooks/useTablet";
import { DashboardNotifications } from "@dev/ee-api/ee-api-models";
import { getDashboardSeenNotificationsStore, UpdateDashboardSeenNotification } from "@/store/dashboardSeenNotifications/actions";
import { getAccountProfileStore, SetMarketingConsentStart } from "@/store/account/actions";
import { SignUpToCreatorsNewsletterBox, SignUpToCreatorsNewsletterButtons, SignUpToCreatorsNewsletterImages, SignUpToCreatorsNewsletterText, SignUpToCreatorsNewsletterWrapper } from "./styles";
import { SignUpToCreatorsNewsletterImage } from './components/SignUpToCreatorsNewsletterImage';

enum SignUpToCreatorsNewsletterVisibility {
    INITIAL = 'initial',
    VISIBLE = 'visible',
    CLOSED = 'closed'
}

export const SignUpToCreatorsNewsletter = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch<any>();
    const isTablet = useTablet();
    const [visibility, setVisiblity] = useState(SignUpToCreatorsNewsletterVisibility.INITIAL);
    const [isJoining, setIsJoining] = useState(false);
    const { MarketingConsent } = useSelector(getAccountProfileStore);

    const { list: dashboardSeenNotifications, isLoaded: dashboardSeenNotificationsLoaded } = useSelector(
        getDashboardSeenNotificationsStore
    );
    const closeNotification = (): void => {
        setVisiblity(SignUpToCreatorsNewsletterVisibility.CLOSED);
        dispatch(UpdateDashboardSeenNotification(DashboardNotifications.CreatorNewsletterNotification));
    };

    const joinNewsletter = (): void => {
        setIsJoining(true);
        dispatch(SetMarketingConsentStart(true)).then(() => {
            setIsJoining(false);
            closeNotification();
        }).catch(() => {
            setIsJoining(false);
        });
    };

    useEffect(() => {
        if (visibility !== SignUpToCreatorsNewsletterVisibility.INITIAL ||
            !dashboardSeenNotificationsLoaded || 
            dashboardSeenNotifications?.includes(DashboardNotifications.CreatorNewsletterNotification) ||
            MarketingConsent === true
        ) {
            return;
        }
        setVisiblity(SignUpToCreatorsNewsletterVisibility.VISIBLE);
    }, [dashboardSeenNotificationsLoaded, dashboardSeenNotifications, MarketingConsent, visibility]);

    if (visibility !== SignUpToCreatorsNewsletterVisibility.VISIBLE) {
        return null;
    }
    return (
        <SignUpToCreatorsNewsletterWrapper>
            <Typography variant="h2">{t('recomendedforyou')}</Typography>
            <SignUpToCreatorsNewsletterBox $isSingleColumn={isTablet}>
                <SignUpToCreatorsNewsletterText>
                    <Typography variant="h2">{t('discovermoregrowfaster')}</Typography>
                    <Typography variant="body1">
                        {t('joinnewsletter_description')}
                    </Typography>
                    <SignUpToCreatorsNewsletterButtons>
                        <WebsitePrimaryButton text={t('joinnewsletter')} onClick={joinNewsletter} disabled={isJoining} isLoading={isJoining} />
                        <TertiaryButton text={t('discard')} onClick={closeNotification} />
                    </SignUpToCreatorsNewsletterButtons>
                </SignUpToCreatorsNewsletterText>
                {!isTablet && 
                    <SignUpToCreatorsNewsletterImages>
                        <SignUpToCreatorsNewsletterImage />
                    </SignUpToCreatorsNewsletterImages>
                }
            </SignUpToCreatorsNewsletterBox>
        </SignUpToCreatorsNewsletterWrapper>
    )
}
